import { endpoints } from '../../api';

export async function loadVoicePreview(voice: { id: string | number; mine?: boolean; preview_url?: string | null }, signal: AbortSignal) {
  if (voice.preview_url?.startsWith('https://')) return { url: voice.preview_url, release() {} };
  if (!voice.mine) throw new Error('voice_preview_unavailable');
  let cursor: string | undefined;
  const seen = new Set<string>();
  do {
    const page = await endpoints.userVoices.list(cursor, signal);
    const own = page.items.find(item => String(item.voice_id) === String(voice.id));
    if (own) {
      if (own.status !== 'ready' || !own.preview_url) throw new Error('voice_preview_unavailable');
      const audio = await endpoints.userVoices.preview(own.id, signal);
      if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
      if (!audio.size || !audio.type.startsWith('audio/')) throw new Error('voice_preview_invalid');
      const url = URL.createObjectURL(audio);
      return { url, release: () => URL.revokeObjectURL(url) };
    }
    cursor = page.next_cursor ?? undefined;
    if (cursor && seen.has(cursor)) throw new Error('voice_cursor_repeated');
    if (cursor) seen.add(cursor);
  } while (cursor && !signal.aborted);
  throw new Error('voice_preview_unavailable');
}
